import { useEffect } from 'react'

import {
    clearPaymentRedirect,
    hasPaymentRedirect,
    subscribePaymentReturn,
} from './payment-redirect'

export const useResetPaymentLoadingOnReturn = (resetLoading: () => void): void => {
    useEffect(() => {
        if (hasPaymentRedirect()) {
            clearPaymentRedirect()
            resetLoading()
        }

        return subscribePaymentReturn(resetLoading)
    }, [resetLoading])
}
